import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// WEBSITE MANAGEMENT APIS (FormData + Base64 JSON)
// ================================
function base64Encode(str) {
  return btoa(unescape(encodeURIComponent(str)));
}
// 🔹 Create Website
export async function createWebsite(websiteData) {
  try {
    const fd = new FormData();
    fd.append("website_data", base64Encode(JSON.stringify(websiteData)));

    const response = await axios.post(`${apiBaseUrl}website/create_website`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createWebsite error:", error);
    return { status: false, type: "danger", success: "Website creation failed" };
  }
}

// 🔹 Delete Website
export async function deleteWebsite(website_id) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}website/delete_website`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteWebsite error:", error);
    return { status: false, type: "danger", success: "Delete request failed" };
  }
}

// 🔹 Get Website List
export async function getWebsites(website_user, page_no = "none", website_status = "", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("website_user", website_user);
    fd.append("page_no", page_no);
    fd.append("website_status", website_status);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}website/get_Websites`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebsites error:", error);
    return { status: false, type: "danger", success: "Failed to fetch websites" };
  }
}

// 🔹 Get Web Report
export async function getWebReport(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}website/get_web_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}

export async function getWebById(website_id) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}website/get_web_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}

export async function getWebContent(website_id,content_length,content_type) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);
    fd.append("content_length", content_length);
    fd.append("content_type", content_type);

    const response = await axios.post(`${apiBaseUrl}website/gen_ai_content`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}
export async function publishWeb(website_id,html_page) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);
    fd.append("website_page", html_page);

    const response = await axios.post(`${apiBaseUrl}website/publish_website`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}

export async function getWebHtml(url) {
  try {
    const fd = new FormData();
    fd.append("url", url);

    const response = await axios.post(`${apiBaseUrl}website/down_html`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}
export async function webToggle(website_id) {
  try {
    const fd = new FormData();
    fd.append("website_id", website_id);

    const response = await axios.post(`${apiBaseUrl}website/toggle_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}
